import { Job } from '../../domain/models/job';
import { Schedule } from '../../domain/models/schedule';
import { JobStatus } from '../../domain/enums/jobStatus';
import * as _ from 'lodash';
import { Position } from '../../domain/models/position';

export class RouteOverviewViewModel {
    public id: string;
    public name: string;
    public userId: string;
    public sharingKey: string;
    public daysCalculated: number;
    public totalDays: number;
    public fromDate: Date;
    public toDate: Date;
    public active: boolean;
    public archived: boolean;
    public createdDate: Date;
    public currentDelay: number;
    public startTime: string;
    public endTime: string;
    public status: JobStatus;
    public finishedAt: Date;

    public startAddress: string;
    public endAddress: string;

    public locations: Position[];

    constructor();
    constructor(job: Job)
    constructor(id: any, name: string, daysCalculated: number, totalDays: number, sharingKey: string,
        fromDate: Date, toDate: Date, active: boolean, archived: boolean, createdDate: Date, currentDelay?: number);
    constructor(idOrJob?: any, name?: string, daysCalculated?: number, totalDays?: number, sharingKey?: string,
        fromDate?: Date, toDate?: Date, active?: boolean, archived?: boolean, createdDate?: Date, currentDelay?: number) {
        if (idOrJob) {
            if (name) {
                this.id = idOrJob;
                this.name = name;
                this.sharingKey = sharingKey;
                this.daysCalculated = daysCalculated;
                this.totalDays = totalDays;
                this.fromDate = fromDate;
                this.toDate = toDate;
                this.active = active;
                this.archived = archived;
                this.createdDate = createdDate;
                this.currentDelay = currentDelay;
            } else {
                this.id = idOrJob.id;
                this.name = idOrJob.name;
                this.sharingKey = idOrJob.sharingKey;
                this.fromDate = idOrJob.start;
                this.toDate = idOrJob.end;
                this.active = new Date().getTime() < this.toDate.getTime();
                this.startTime = idOrJob.schedule.startTime;
                this.endTime = idOrJob.schedule.endTime;
                this.totalDays = 0;
                this.daysCalculated = 0;
                this.archived = idOrJob.archived;
                this.createdDate = idOrJob.createdAt;
                this.status = idOrJob.status;
                this.userId = idOrJob.userId;
                this.finishedAt = idOrJob.finishedAt;
                this.startAddress = idOrJob.startAddress;
                this.endAddress = idOrJob.endAddress;
                this.locations = idOrJob.locations;

                this.calulateTotalDays(idOrJob.schedule, idOrJob.start, idOrJob.end, this.finishedAt);
            }
        }
    }

    private calulateTotalDays(schedule: Schedule, startDate: Date, endDate: Date, finishedAt: Date): void {
        let stop = new Date(endDate);
        stop.setHours(0, 0, 0, 0);
        let today = new Date();
        if (finishedAt) {
            today = new Date(finishedAt);
            today.setDate(today.getDate() + 1);
        }
        today.setHours(0, 0, 0, 0);

        let start = new Date(startDate);
        start.setHours(0, 0, 0, 0);

        for (let i = new Date(start); i <= stop; i.setDate(i.getDate() + 1)) {
            if (_.includes(schedule.days, i.getDay())) {
                this.totalDays++;
                if (i < today) {
                    this.daysCalculated++;
                }
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/route-overview/viewModels/route-overview.viewModel.ts